import * as UserActions from './../actions/user_actions';
import extend from 'lodash/extend';
// import * as SettingScreen from './../actions/settingScreen';


export var User = (state = {
    OTPResponse: null,
    loginData: null,
    getUserName: null,
    LoginFailed: null,
    PasswordDetail: null,
    securityQuesitons: null,
    IsLoggingIn: false,
    // ChangePasswordFaild: null,
    // verification: null,
    //ProfileUpdate: null,
    verificationResponse: null,
    //questionsUpdate: null,
    DoctorList: null,
    //Registration
    highestDegrees: null,
    professionalRoles: null,
    ethnicities: null,
    // survey_list_data
    surveyListData: null,
    logout: null,
    TriggerTime: null,
    currentStaffMember: null,
    TheraoistList: null,
    PsychiatristList: null,
    PatientList: null,
    //Staff registration upload csv
    FileUploadRegistrationResponse: null,
    patentSuervyResponseData: null,

    UsersByRole: null,
    sessionLogoutResponse: null,
    autoLogOutTime: 0,
    sessionExpired: null,
    selectedUserRoleID: null,
    selectdUserFacilityID: null,
    MultifacilityRequest: null, facilitiCreatedDate: '',
    userDeleted: null,
    userImage: null,
    selectedClinicName: null

}, action) => {

    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case "@@redux/INIT": {
        }
        case 'persist/REHYDRATE': {
            if (action.payload && action.payload.User) {
                action.payload.User.IsLoggingIn = false;
                return extend({}, state, action.payload.User);
            } else {
                return state;
            }
        }
            break;

        case UserActions.OTP_SUCCESS: {
            return extend({}, state, { OTPResponse: action.data });
        }

        case UserActions.MULTI_FACILITY_REQUEST:
            {
                return extend({}, state, { MultifacilityRequest: action.data });
            }
            break;


        case UserActions.SESSION_EXPIRED:
            {
                return extend({}, state, { sessionExpired: action.data });
            }
            break;
        case UserActions.AUTO_LOGOUT_TIME:
            {
                return extend({}, state, { autoLogOutTime: action.data });
            }
            break;
        case UserActions.USER_LOGGING_DATA:
            {

                let autoLogutSetting = {}, d1 = new Date(), d2 = new Date(d1), backendSessionLogoutTime = +action.data.data.sessionExpiredTime;
                d2.setMinutes(d1.getMinutes() + backendSessionLogoutTime);
                autoLogutSetting.autoLogOutTimeer = backendSessionLogoutTime;
                autoLogutSetting.autoLogOutTime = d2;
                if (window.localStorage) {

                    localStorage.setItem('autoLogOut', JSON.stringify(autoLogutSetting));
                } else {
                    window.autoLogOutTime = autoLogutSetting;
                }
                return extend({}, state, { loginData: action.data });
            }
            break;
        case UserActions.USER_LOGGING_FAILED:
            {
                return extend({}, state, { loginData: action.data });
            }
            break;

        case UserActions.USER_FACILITY_ID:
            {
                return extend({}, state, { selectdUserFacilityID: action.data });
            }
            break;
        case UserActions.USER_ROLE_ID:
            {
                return extend({}, state, { selectedUserRoleID: action.data });
            }
            break;
        case UserActions.FACILIT_CREATED_DATE:
            {
                return extend({}, state, { facilitiCreatedDate: action.data });
            }
            break;
        case UserActions.FORGOT_USER_NAME:
            {
                return extend({}, state, { getUserName: action.data });
            }
            break;
        case UserActions.FORGOT_USER_NAME_FAIL:
            {
                return extend({}, state, { getUserName: action.data });
            }
            break;
        case UserActions.USER_LOGGING_IN_FAILED: {
            return extend({}, state, {
                LoginFailed: false
            });
        }
            break;
        case UserActions.FORGOT_PASSWORD: {
            return extend({}, state, { PasswordDetail: action.data });
        }
            break;
        case UserActions.VERIFY_SECURITY_QUESTION: {
            return extend({}, state, { verificationResponse: action.data })
        }
            break;

        // To Verify the answers of User selected Security Questions in Reset Password flow
        case UserActions.VERIFY_SECURITYQS_FAILD: {
            return extend({}, state, { verificationResponse: action.data })
        }
            break;

        // Registration
        case UserActions.GET_HEIGHEST_DEGREES: {
            return extend({}, state, { highestDegrees: action.data })
        }
            break;

        case UserActions.GET_PROFESSIONAL_ROLES: {
            return extend({}, state, { professionalRoles: action.data })
        }
            break;

        case UserActions.GET_ETHNICITIES: {
            return extend({}, state, { ethnicities: action.data })
        }
            break;
        case UserActions.GET_SURVEY_LIST: {
            return extend({}, state, { surveyListData: action.data })
        }
            break;

        case UserActions.SET_CURRENT_STAFF_MEMBER: {
            return extend({}, state, { currentStaffMember: action.data })
        }
            break;
        case UserActions.GET_THERAPIST_LIST: {
            return extend({}, state, { TheraoistList: action.data })
        }
            break;
        case UserActions.GET_PSYCHIATRIST_LIST: {
            return extend({}, state, { PsychiatristList: action.data })
        }
            break;


        case UserActions.USER_TRIGGER_TIME: {
            return extend({}, state, { TriggerTime: action.data })
        }
            break;
        case UserActions.FILLTER_PATIENT_BY_DR: {
            return extend({}, state, { UsersByRole: action.data }) // replaced PatientList with UsersByRole both represents same response
        }
            break;
        // for staff registration upload csv
        case UserActions.FILE_UPLOAD_REGISTRATION: {
            return extend({}, state, { FileUploadRegistrationResponse: action.data });
        }
            break;
        case UserActions.USER_REDFLAG_RESLOVE: {
            return extend({}, state, { RedFlagreslove: action.data }) // replaced PatientList with UsersByRole both represents same response
        }
            break;

        case UserActions.SESSION_LOGOUT: {
            return extend({}, state, { sessionLogoutResponse: action.data });
        }
            break;
        case UserActions.USER_LOG_OUT: {
            return extend({}, state, {
                OTPResponse: null,
                loginData: null,
                getUserName: "",
                LoginFailed: "",
                PasswordDetail: "",
                securityQuesitons: "",
                IsLoggingIn: "",
                verificationResponse: "",
                questionsUpdate: "",
                highestDegrees: "",
                professionalRoles: "",
                ethnicities: "",
                surveyListData: "",
                currentStaffMember: "",
                DoctorList: null,
                TriggerTime: null,
                logout: true,
                PatientList: null,
                TheraoistList: null,
                PsychiatristList: null,
                FileUploadRegistrationResponse: null,
                UsersByRole: null, facilitiCreatedDate: '',
                sessionLogoutResponse: null, autoLogOutTime: 0, sessionExpired: null, selectedUserRoleID: null, selectdUserFacilityID: null
            })
        }
            break;
        case UserActions.PATIENT_SURVEY_RESPONSE_DATA: {
            return extend({}, state, { patentSuervyResponseData: action.data });
        }
            break;

        case UserActions.USERS_BY_ROLE: {
            return extend({}, state, { UsersByRole: action.data });
        }
            break;
        case UserActions.ADDQUESTIONSTOSURVEY_DATA: {
            return extend({}, state, { AddQuestionSurvey: action.data });
        }
            break;
        case UserActions.USER_DELETE: {
            return extend({}, state, { userDeleted: action.data });
        }
            break;
        case UserActions.USER_PROFILE_IMAGE: {
            return extend({}, state, { userImage: action.data });
        }
            break;
        case UserActions.SELECTED_CLINIC_NAME: {
            return extend({}, state, { selectedClinicName: action.data });
        }
            break;


        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/user_reducer.js
 **/